var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAll = function SvgAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#All_svg__clip0_1022_212400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.415 3.129V1.066h-7.48V3.13L11 5.19v10.313l.935 2.062h7.48l.935-2.062V5.19l-.935-2.062z",
    fill: "url(#All_svg__paint0_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.415 3.129h-.935a.447.447 0 01-.33-.151.544.544 0 01-.137-.365c0-.136.049-.268.137-.364a.447.447 0 01.33-.151h.935v1.03z",
    fill: "url(#All_svg__paint1_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M11.935 2.098h4.675c.124 0 .242.054.33.15a.544.544 0 01.137.365c0 .137-.05.268-.137.365a.447.447 0 01-.33.15h-4.675v-1.03z",
    fill: "url(#All_svg__paint2_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.191h9.35v10.313H11V5.19z",
    fill: "#E84A47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.103 15.504c.822-1.598 1.602-3.094 1.602-5.672 0-1.619-.502-3.162-1.032-4.64h-1.87c.53 1.478 1.032 3.021 1.032 4.64 0 2.578-.78 4.073-1.602 5.672h1.87z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.836 18.12a8.26 8.26 0 01-4.872 2.029h-.008c-.342.031-.7.051-1.078.051a9.085 9.085 0 01-4.96-1.325l-.008-.004C.16 18.395.001 17.87 0 17.211c-.001-.66.693-2.002 1.09-2.781v-.004l4.068-8.412a.802.802 0 011.44 0L12.01 17.21a.783.783 0 01-.175.91z",
    fill: "url(#All_svg__paint3_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.23 17.546a.786.786 0 01-.25.573c-.772.716-2.673 2.08-5.958 2.08H5.878c.378 0 .736-.02 1.078-.051h.008a8.259 8.259 0 004.872-2.029c.25-.233.322-.6.175-.91L6.598 6.013a.796.796 0 00-.72-.447h2.144a.792.792 0 01.72.447l5.413 11.196c.05.105.076.22.075.337z",
    fill: "url(#All_svg__paint4_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.088 18.223c.55 0 .994-.443.994-.99a.992.992 0 00-.994-.988.992.992 0 00-.994.989c0 .546.445.988.994.988z",
    fill: "url(#All_svg__paint5_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083 13.08c.439 0 .795-.353.795-.79a.793.793 0 00-.795-.791.793.793 0 00-.796.791c0 .437.356.79.796.79z",
    fill: "url(#All_svg__paint6_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.065 17.431c.769 0 1.392-.62 1.392-1.384 0-.764-.623-1.384-1.392-1.384-.769 0-1.392.62-1.392 1.384 0 .765.623 1.384 1.392 1.384z",
    fill: "url(#All_svg__paint7_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.468 12.685c.22 0 .398-.177.398-.395a.397.397 0 00-.398-.395.397.397 0 00-.398.395c0 .218.178.396.398.396z",
    fill: "url(#All_svg__paint8_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.889 14.663c.22 0 .398-.177.398-.395a.397.397 0 00-.398-.396.397.397 0 00-.398.396c0 .218.178.395.398.395z",
    fill: "url(#All_svg__paint9_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.275 10.708a.397.397 0 100-.791.397.397 0 00-.398.396c0 .218.178.395.398.395z",
    fill: "url(#All_svg__paint10_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.578 13.999L8.87 16.433l.36 1.924c.288 1.533 1.547 2.756 3.16 2.912a13.82 13.82 0 007.66-1.467 3.612 3.612 0 001.92-3.674l-.392-2.129z",
    fill: "url(#All_svg__paint11_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 16.432l.36 1.924c.288 1.533 1.547 2.756 3.16 2.912 1.894.183 3.79-.025 5.583-.604.005-.946-.535-1.87-.535-1.87l-.724-3.864-7.844 1.502z",
    fill: "#935B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 16.433c-.535-2.858 2.075-3.304 4.04-3.194 1.53.087 2.395-1.185 3.555-1.781a3.543 3.543 0 014.788 1.58c.891 1.772.191 3.94-1.562 4.84a13.821 13.821 0 01-7.66 1.467c-1.614-.156-2.873-1.379-3.16-2.912z",
    fill: "url(#All_svg__paint12_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.91 13.24c-1.964-.111-4.575.335-4.04 3.193.288 1.534 1.547 2.756 3.16 2.912a13.807 13.807 0 005.409-.55c-1.77-1.928-4.055-.7-5.137-2.594-1.205-2.11.607-2.961.607-2.961z",
    fill: "url(#All_svg__paint13_linear_1022_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.765 18.104c-4.099.785-5.64-.777-5.845-1.87-.04-.217-.298-1.595 1.362-1.833.45-.065 2.158-.084 2.445-.139.97-.186 1.682-.732 2.31-1.215.319-.244 1.056-.755 1.578-.855a2.497 2.497 0 012.685 1.336c.302.6.354 1.283.148 1.923-.207.64-1.387 2.021-4.683 2.653z",
    fill: "#F2B4B1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M19.217 14.42c.109.583-.27 1.144-.846 1.254a1.062 1.062 0 01-1.24-.854c-.11-.582.27-1.144.845-1.254a1.062 1.062 0 011.24.854z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.302 16.2c-.447-.783-.478-1.392-.341-1.85a8.717 8.717 0 00-.679.049c-1.66.239-1.402 1.616-1.361 1.833.205 1.093 1.746 2.655 5.845 1.87.203-.039.397-.08.584-.125-1.531-.748-3.179-.254-4.048-1.776z",
    fill: "url(#All_svg__paint14_linear_1022_212400)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint0_linear_1022_212400",
    x1: 15.675,
    y1: 1.066,
    x2: 15.675,
    y2: 17.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint1_linear_1022_212400",
    x1: 18.008,
    y1: 3.293,
    x2: 19.883,
    y2: 3.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint2_linear_1022_212400",
    x1: 11.918,
    y1: 3.293,
    x2: 15.288,
    y2: 3.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint3_linear_1022_212400",
    x1: 6.499,
    y1: 5.567,
    x2: 6.499,
    y2: 20.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint4_linear_1022_212400",
    x1: 8.916,
    y1: 5.544,
    x2: 10.041,
    y2: 20.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4B912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint5_linear_1022_212400",
    x1: 3.941,
    y1: 14.909,
    x2: 4.073,
    y2: 18.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29C1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint6_linear_1022_212400",
    x1: 4.965,
    y1: 10.43,
    x2: 5.07,
    y2: 13.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29C1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint7_linear_1022_212400",
    x1: 7.859,
    y1: 12.792,
    x2: 8.043,
    y2: 17.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29C1F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint8_linear_1022_212400",
    x1: 7.468,
    y1: 11.895,
    x2: 7.468,
    y2: 12.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C419",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint9_linear_1022_212400",
    x1: 3.889,
    y1: 13.872,
    x2: 3.889,
    y2: 14.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C419",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint10_linear_1022_212400",
    x1: 6.275,
    y1: 9.917,
    x2: 6.275,
    y2: 10.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0C419",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint11_linear_1022_212400",
    x1: 21.522,
    y1: 14.416,
    x2: 12.239,
    y2: 21.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2785B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint12_linear_1022_212400",
    x1: 18.757,
    y1: 11.066,
    x2: 10.753,
    y2: 19.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8CAB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint13_linear_1022_212400",
    x1: 13.119,
    y1: 13.225,
    x2: 11.726,
    y2: 19.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7DDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBCDB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "All_svg__paint14_linear_1022_212400",
    x1: 11.935,
    y1: 13.671,
    x2: 12.498,
    y2: 18.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA2A2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA2A2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "All_svg__clip0_1022_212400"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/All.f4bd97e5.svg";
export { SvgAll as ReactComponent };